(function () {
  function inject() {
    var tpl = document.getElementById('nsm-payment-methods-tpl');
    if (!tpl) return;

    var forms = document.querySelectorAll('form[id^="main-product-form-"]');
    forms.forEach(function (form) {
      if (form.querySelector('.nsm-payment-methods')) return;
      var submitBlock = form.querySelector('.submit');
      if (!submitBlock) return;
      submitBlock.after(tpl.content.cloneNode(true));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  var observer = new MutationObserver(inject);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
